import 'core-js';

import React from 'react';
import ReactDOM from 'react-dom';
import common from 'common-web';

import './index.css';
import 'react-day-picker/lib/style.css';
import 'react-select/dist/react-select.css';
import Form from './Form';

common.environment.set(process.env.REACT_APP_ENV);
ReactDOM.render(<Form locale={{language:'en',country:'US',localeCode:'en_US'}}/>, document.getElementById('root'));




// WEBPACK FOOTER //
// ./src/index.js